export default __webpack_public_path__ + "static/media/hdSofa.0f88ced2.svg";